import Box from '@mui/material/Box';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { DEFAULT_TABLE_CLASS_NAME } from '../../theme/constants/table';
import { getNextSortModel } from './utils/selectionModelHandlers';

const FingoTableHead = (props) => {
  const {
    columns,
    checkboxSelection,
    collapsible,
    sortModel,
    onSortModelChange,
    tableClassName,
  } = props;

  const sortDirection = useMemo(() => sortModel[0]?.sort, [sortModel]);

  const sortClickHandler = (headerName) => {
    onSortModelChange(getNextSortModel(headerName, sortModel));
  };

  return (
    <TableHead>
      <TableRow sx={{ height: 10 }}>
        {((checkboxSelection || collapsible)) && <TableCell padding="checkbox" />}
        {columns.map((column) => (
          <TableCell
            key={column.field}
            align={column.headerAlign || column.align || 'inherit'}
            sortDirection={column.sortable && sortDirection}
            className={tableClassName}
          >
            <TableSortLabel
              active={column.sortable && !!sortModel[0]?.field?.includes(column.field)}
              hideSortIcon={!column.sortable}
              direction={sortDirection}
              onClick={() => column.sortable && sortClickHandler(column.field)}
              sx={{ display: 'flex', justifyContent: column.headerAlign || column.align || 'left' }}
            >
              {column.headerName}
              {column.sortable && !!sortModel[0]?.field?.includes(column.field) && (
                <Box component="span" sx={visuallyHidden} fontSize={6}>
                  {sortDirection === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              )}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

FingoTableHead.propTypes = {
  columns: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string.isRequired,
      headerName: PropTypes.string,
      sortable: PropTypes.bool,
      renderCell: PropTypes.func,
      valueGetter: PropTypes.func,
      align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
      headerAlign: PropTypes.oneOf(['left', 'center', 'right']),
    }),
  ).isRequired,
  checkboxSelection: PropTypes.bool.isRequired,
  collapsible: PropTypes.bool.isRequired,
  sortModel: PropTypes.arrayOf(
    PropTypes.shape({
      field: PropTypes.string,
      sort: PropTypes.string,
    }),
  ).isRequired,
  onSortModelChange: PropTypes.func.isRequired,
  tableClassName: PropTypes.string,
};

FingoTableHead.defaultProps = {
  tableClassName: DEFAULT_TABLE_CLASS_NAME,
};

export default FingoTableHead;
